import 'choerodon-ui/lib/style/index.less';
import './index.less';
// style dependencies
import '../../progress/style';
import '../../ripple/style';
